module.exports = __webpack_public_path__ + "static/media/Coche color.e4308a7a.jpg";